/**
 * Fixes the "BOTANİCS" rendering bug: wherever a "Botanics" (or "Botanics+")
 * text run sits inside an element the theme uppercases via CSS
 * (text-transform: uppercase), the page's Turkish locale (html lang="tr")
 * makes the browser uppercase "i" to the dotted Turkish "İ" instead of the
 * plain ASCII "I", rendering "BOTANİCS".
 *
 * This does not touch the underlying text ("Botanics" stays "Botanics" in
 * the DOM/content) and does not force any transform itself — it only wraps
 * the "Botanics" substring in a <span lang="en"> so that IF an ancestor
 * uppercases it, the browser uses English casing for just that word.
 * Surrounding Turkish text (e.g. "Nemlendirici") keeps its own casing
 * untouched. Runs once on load and keeps watching for content added later
 * (AJAX recommendations, cart drawer, quick add, search).
 */
(function () {
  const BRAND_PATTERN = /Botanics(\+)?/g;
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'TEXTAREA', 'INPUT', 'IFRAME']);

  function shouldSkip(element) {
    while (element) {
      if (SKIP_TAGS.has(element.tagName)) return true;
      if (element.tagName === 'SPAN' && element.lang === 'en' && element.dataset.brandCaseFix === 'true') return true;
      if (element.isContentEditable) return true;
      element = element.parentElement;
    }
    return false;
  }

  function wrapMatches(node) {
    const text = node.nodeValue;
    BRAND_PATTERN.lastIndex = 0;
    if (!BRAND_PATTERN.test(text)) return;
    BRAND_PATTERN.lastIndex = 0;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = BRAND_PATTERN.exec(text))) {
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }

      const span = document.createElement('span');
      span.lang = 'en';
      span.dataset.brandCaseFix = 'true';
      span.textContent = match[0];
      fragment.appendChild(span);

      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    node.replaceWith(fragment);
  }

  function collectTextNodes(root, results) {
    if (root.nodeType === Node.TEXT_NODE) {
      results.push(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root instanceof Element && shouldSkip(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) {
      if (!shouldSkip(textNode.parentElement)) results.push(textNode);
    }
  }

  function processSubtree(root) {
    const candidates = [];
    collectTextNodes(root, candidates);

    for (const node of candidates) {
      if (node.isConnected && node.nodeValue && node.nodeValue.includes('Botanics')) {
        wrapMatches(node);
      }
    }
  }

  function init() {
    processSubtree(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => processSubtree(node));
        } else if (mutation.type === 'characterData') {
          if (mutation.target.nodeValue && mutation.target.nodeValue.includes('Botanics')) {
            wrapMatches(mutation.target);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
